module.exports = __webpack_public_path__ + "img/cpasmnticon.39068b2c.svg";